// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiFormatListCheckbox } from "@mdi/js";
import { Button, Tooltip } from "antd";

interface IRigFracDetailsButtonProps {
  viewLayerDetails: () => void;
}

/**
 * Opens the layer details drill-in for a rig/frac layer row. Viewing the
 * details is the only row action, so the icon sits directly beside the
 * settings cog and fires on a single click.
 */
export function RigFracDetailsButton({
  viewLayerDetails
}: IRigFracDetailsButtonProps): JSX.Element {
  return (
    <Tooltip title="View Layer Details">
      <Button
        type="text"
        aria-label="View Layer Details"
        data-testid="rig-frac-details-button"
        onClick={(evt) => {
          viewLayerDetails();
          evt.stopPropagation();
          evt.preventDefault();
        }}>
        <Icon path={mdiFormatListCheckbox} size={"18px"} />
      </Button>
    </Tooltip>
  );
}
